import * as React from "react";
/* empty css                             */
import { useProductBlockSlots } from "../../../../../../../../../slots/ProductBlock/slots/context.js";
const ProductBlockHeaderRight = ({ sku, productLocation, tabIndex }) => {
  const { Slots } = useProductBlockSlots();
  if (!Slots.WishlistButton) return null;
  return /* @__PURE__ */ React.createElement("div", { className: "product-block-header-right" }, /* @__PURE__ */ React.createElement(Slots.WishlistButton, { sku, productLocation, tabIndex }));
};
export {
  ProductBlockHeaderRight
};
//# sourceMappingURL=ProductBlockHeaderRight.js.map
